import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { interactionMessageApi } from '../../api/interactionMessage';

// 获取消息列表
export const fetchMessageList = createAsyncThunk(
  'interactionMessage/fetchList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await interactionMessageApi.getMessageList(params);
      return response.data ?? response;
    } catch (error) {
      return rejectWithValue(error?.message || '获取互动消息列表失败');
    }
  }
);

// 获取消息统计信息
export const fetchMessageStatistics = createAsyncThunk(
  'interactionMessage/fetchStatistics',
  async (params, { rejectWithValue }) => {
    try {
      const response = await interactionMessageApi.getMessageStatistics(params);
      return response.data ?? response;
    } catch (error) {
      return rejectWithValue(error?.message || '获取消息统计失败');
    }
  }
);

// 获取消息类型统计
export const fetchMessageTypeStatistics = createAsyncThunk(
  'interactionMessage/fetchTypeStatistics',
  async (params, { rejectWithValue }) => {
    try {
      const response = await interactionMessageApi.getMessageTypeStatistics(params);
      return response.data ?? response;
    } catch (error) {
      return rejectWithValue(error?.message || '获取消息类型统计失败');
    }
  }
);

// 获取消息趋势数据
export const fetchMessageTrendData = createAsyncThunk(
  'interactionMessage/fetchTrendData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await interactionMessageApi.getMessageTrendData(params);
      return response.data ?? response;
    } catch (error) {
      return rejectWithValue(error?.message || '获取消息趋势数据失败');
    }
  }
);

// 获取互动消息统计概览
export const fetchInteractionStatsOverview = createAsyncThunk(
  'interactionMessage/fetchStatsOverview',
  async (queryDTO, { rejectWithValue }) => {
    try {
      const response = await interactionMessageApi.getInteractionStatsOverview(queryDTO);
      if (response && (response.code === 200 || response.success)) {
        return response.data;
      }
      return rejectWithValue(response?.message || '获取互动消息统计概览失败');
    } catch (error) {
      return rejectWithValue(error?.message || '获取互动消息统计概览失败');
    }
  }
);

// 创建消息
export const createInteractionMessage = createAsyncThunk(
  'interactionMessage/create',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await interactionMessageApi.createMessage(data);
      dispatch(fetchMessageList());
      dispatch(fetchMessageStatistics());
      return response.data ?? response;
    } catch (error) {
      return rejectWithValue(error?.message || '创建互动消息失败');
    }
  }
);

// 批量标记消息为已读
export const markMessagesAsRead = createAsyncThunk(
  'interactionMessage/markRead',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await interactionMessageApi.markMessagesAsRead(data);
      dispatch(fetchMessageList());
      dispatch(fetchMessageStatistics());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 删除消息
export const deleteMessages = createAsyncThunk(
  'interactionMessage/delete',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await interactionMessageApi.deleteMessages(data);
      dispatch(fetchMessageList());
      dispatch(fetchMessageStatistics());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const interactionMessageSlice = createSlice({
  name: 'interactionMessage',
  initialState: {
    messageList: [],
    messageStatistics: null,
    messageTypeStatistics: null,
    messageTrendData: null,
    interactionStatsOverview: null,
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 获取消息列表
      .addCase(fetchMessageList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMessageList.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload || [];
        state.messageList = Array.isArray(payload.records) ? payload.records : (Array.isArray(payload) ? payload : []);
      })
      .addCase(fetchMessageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // 消息统计信息
      .addCase(fetchMessageStatistics.fulfilled, (state, action) => {
        state.messageStatistics = action.payload;
      })
      
      // 消息类型统计
      .addCase(fetchMessageTypeStatistics.fulfilled, (state, action) => {
        state.messageTypeStatistics = action.payload;
      })
      
      // 消息趋势数据
      .addCase(fetchMessageTrendData.fulfilled, (state, action) => {
        state.messageTrendData = action.payload;
      })
      // 互动消息统计概览
      .addCase(fetchInteractionStatsOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInteractionStatsOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.interactionStatsOverview = action.payload || null;
      })
      .addCase(fetchInteractionStatsOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 创建消息
      .addCase(createInteractionMessage.pending, (state) => {
        state.loading = true;
      })
      .addCase(createInteractionMessage.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createInteractionMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default interactionMessageSlice.reducer; 